import TtamAdName from './ad-name/index.vue';
import TtamAdNameTips from './tips/index.vue';
import TtamAdNameAddButton from './add-button/index.vue';
import * as hooks from './hooks';
export default {
  TtamAdName,
  TtamAdNameTips,
  TtamAdNameAddButton,
  ...hooks,
};
